import React, { useEffect, useRef, useState } from "react";
import OcButton from "../components/OcButton";
import WaitlistModal from "../components/WaitlistModal";
import useOcReveal from "../useOcReveal";
import "./Cta.scss";

import iphone from "../../../assets/images/home/09-cta/cta-iphone.png";
import grady from "../../../assets/images/home/09-cta/grady-holding-phone.png";
import pattern from "../../../assets/images/home/09-cta/bottom-cta-box-background.png";

export default function Cta() {
  const [modalOpen, setModalOpen] = useState(false);
  const sectionRef = useRef(null);
  const patternRef = useRef(null);
  useOcReveal(sectionRef);

  // Prototype: while scrolling into the CTA, the halftone tracks in from the
  // right (Figma overflow / while-scrolling), not a one-shot fade.
  useEffect(() => {
    const section = sectionRef.current;
    const pattern = patternRef.current;
    if (!section || !pattern) return undefined;

    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) {
      pattern.style.transform = "none";
      return undefined;
    }

    let raf = 0;
    const update = () => {
      raf = 0;
      const rect = section.getBoundingClientRect();
      const vh = window.innerHeight;
      const start = vh * 0.95;
      const end = vh * 0.28;
      const p = Math.min(1, Math.max(0, (start - rect.top) / (start - end)));
      const eased = 1 - (1 - p) ** 3;
      pattern.style.transform = `translateX(${((1 - eased) * 70).toFixed(2)}%)`;
    };

    const onScroll = () => {
      if (!raf) raf = requestAnimationFrame(update);
    };

    update();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <section className="cta" id="cta" ref={sectionRef}>
      <div className="cta__stage">
        {/* Grady peeks over the top-left corner of the box (outside the box so
            his head isn't clipped by the box's overflow) */}
        <img
          className="cta__grady oc-reveal"
          src={grady}
          alt=""
          aria-hidden="true"
          loading="lazy"
          style={{ "--oc-delay": "0.08s" }}
        />

        <div className="cta__box">
          {/* Soft teal wash on the right (Figma "Bottom CTA Box Background") */}
          <span className="cta__glow" aria-hidden="true" />

          {/* Halftone dots — Figma 900×400 layer, denser on the right */}
          <img
            ref={patternRef}
            className="cta__pattern"
            src={pattern}
            alt=""
            aria-hidden="true"
          />

          <div className="cta__content oc-reveal">
            <div className="cta__copy">
              <h2 className="cta__title">Your Mind is ready to help</h2>
              <p className="cta__text">
                Chat with an AI agent that remembers your goals, follows up, and
                helps you move things forward.
              </p>
            </div>

            <OcButton
              variant="white"
              className="cta__cta"
              onClick={() => setModalOpen(true)}
            >
              Get early access
            </OcButton>
          </div>

          {/* Study Buddy chat mockup, tilted; clipped by the box on the right */}
          <img
            className="cta__phone oc-reveal"
            src={iphone}
            alt="Open Campus Study Buddy chat"
            loading="lazy"
            style={{ "--oc-delay": "0.16s" }}
          />
        </div>
      </div>

      <WaitlistModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        variant="minds"
      />
    </section>
  );
}
